import {
  bannerHeight,
  filterBarHeight,
  headerContentHeight,
} from 'src/components/PageLayout/dimensionUtils'
import styled, { css } from 'styled-components/macro'
import palette from 'src/designSystem/variables/palette'
import { FlexAlign } from '../Flex'
import { GridColumn, GridHeader, GridRow } from './Grid'

export const CenteredGridColumn = styled(GridColumn)`
  justify-content: center;
`

export const NoPaddingGridColumn = styled(GridColumn)`
  padding: 0px;
`

export const StickyGridHeader = styled(GridHeader).attrs(
  ({ $top, $bannerCount }: { $top?: number; $bannerCount: number }) => ({
    top: $top
      ? $top
      : headerContentHeight + filterBarHeight + $bannerCount * bannerHeight,
  }),
)<{ $gridAlign?: FlexAlign; $top?: number; $bannerCount?: number }>`
  position: sticky;
  z-index: 1;
  ${({ $gridAlign }) => {
    if (!$gridAlign) return ''
    return `justify-content: ${$gridAlign};`
  }}
`

export const StyledAccordionGridRow = styled(GridRow)<{
  isExpanded?: boolean
}>`
  cursor: pointer;

  .grid-column {
    margin-bottom: 8px;
    border-top: 1px solid ${palette.neutral['100']};
    border-bottom: 1px solid ${palette.neutral['100']};
    overflow: hidden;
  }

  .grid-column:first-child {
    border-left: 1px solid ${palette.neutral['100']};
  }

  .grid-column:last-child {
    border-right: 1px solid ${palette.neutral['100']};
  }

  ${({ isExpanded }) =>
    isExpanded &&
    css`
      .grid-column {
        border-bottom: none;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        margin-bottom: 0;
      }
    `}
`

export const StyledAccordionGridRowContent = styled.div`
  grid-column: 1 / -1;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border: 1px solid ${palette.neutral['100']};
  border-top: none;
  margin-bottom: 8px;
`
